const { url_base } = require("./clientToCompile")

const debug = false

const url_images = window.location.protocol + "//" + window.location.host + "/images"

const datos = {
  urlapi: debug === true ? 'http://localhost:5004/api/web/1.0' : `${url_base}/api/web/1.0`,
  key_local_storage_user: 'mz_bknd_user',
  ultimo_doc: 'ultimo_doc_generado',
  key_local_storage_cart: 'mz_bknd_cart',
  key_local_client: 'mz_bknd_client',
  key_local_storage_pedidos: 'mz_bknd_pedidos',
  pagina: 20,
  maps_key: "AIzaSyBVfuPv1M8VqoDLy_wXNX3KGMMfgi-OIRM",
  tipos_direccion: ['geocode'],
  mapbox_token: "pk.eyJ1IjoiY2FybG9zZGVscGEiLCJhIjoiY2xreTBqeDQwMHphcjNrbzJzbW4weTMweiJ9._pOF3JQBp_uT78K0B1KlbA",

  iva_global: 1.19,
  timezone: "America/Santiago",
  url_images,
  url_front: "https://pos.wesyncro.com",
  configs3: {
    dirName: "agf/",
    bucketName: "testing-agf",
    region: "us-west-2",
    accessKeyId: 'AKIAYXYN322Y2VEKQMX5',
    secretAccessKey: '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',
  },
  marketplaces: [
    {
      logo: `${url_images}/woocommerce.png`,
      name: 'woocommerce',
      pais: "CL"
    },
    {
      logo: `${url_images}/marketplaces/magento.png`,
      name: 'magento',
      pais: "CL"
    },
    {
      logo: `${url_images}/marketplaces/jumpseller.png`,
      name: 'jumpseller',
      pais: "CL"
    },
    {
      logo: `${url_images}/marketplaces/shopify.png`,
      name: 'shopify',
      pais: "CL"
    },
    {
      logo: `${url_images}/marketplaces/prestashop.png`,
      name: 'prestashop',
      pais: "CL"
    }
  ],
  mercadolibre_config: {
    client_id: "8686228924463533",
    redirect_uri: "https://lastmile.delpasystem.com/integraciones/mercadolibre/login"
  },
  pasarelas: [
    { name: "transbank", description: "Webpay One Click", logo: `${url_images}/payments_methods/oneclick.png` },
    { name: "mercadopago", description: "Mercado Pago", logo: `${url_images}/payments_methods/mercado-pago.png` },
  ],
  colores: {
    0: "#0028ff",  // Gris Pizarra
    1: "#ff8300",  // Rosado Pálido
    2: "#b40b6a",  // Verde Oliva
    3: "#0ba4b4",  // Acero Azul
    4: "#b40b0b",  // Bronceado
    5: "#b4920b",  // Turquesa Oscuro
    6: "#50b40b",  // Verde Oscuro Oliva
    7: "#0b84b4",  // Verde Mar Oscuro
    8: "#5f0bb4",  // Lila Oscuro
    9: "#8B0000",  // Rojo Oscuro
    10: "#E9967A", // Salmón Oscuro
    11: "#483D8B", // Azul Pizarra Oscuro
    12: "#2F4F4F", // Verde Pizarra Oscuro
    13: "#00CED1", // Turquesa Oscuro
    14: "#9400D3", // Violeta Oscuro
    15: "#FF8C00", // Naranja Oscuro
    16: "#696969", // Gris Oscuro
    17: "#1E90FF", // Azul Dodger
    18: "#B22222", // Ladrillo Refractario
    19: "#FFD700", // Dorado
    20: "#ADFF2F", // Verde Amarillo
    21: "#F0E68C", // Caqui
    22: "#E6E6FA", // Lavanda
    23: "#FFF0F5", // Lavanda Rosada
    24: "#7B68EE", // Azul Medio Pizarra
    25: "#6A5ACD", // Azul Pizarra
    26: "#20B2AA", // Verde Mar Claro
    27: "#778899", // Gris Pizarra Claro
    28: "#B0C4DE", // Acero Azul Claro
    29: "#FFFFE0", // Amarillo Claro
    30: "#00FA9A", // Verde Primavera Medio
    31: "#48D1CC", // Turquesa Medio
    32: "#C71585", // Rojo Violeta Medio
    33: "#191970", // Azul Marino Medianoche
    34: "#F5FFFA", // Menta Crema
    35: "#FFE4E1", // Rosado Místico
    36: "#FFDEAD", // Blanquecino Navajo
    37: "#FFDAB9", // Melocotón
    38: "#CD853F", // Perú
    39: "#FFC0CB", // Rosado
    40: "#DDA0DD", // Ciruela
    41: "#B0E0E6", // Azul Polvo
    42: "#800080", // Púrpura
    43: "#663399", // Rebecca Púrpura
    44: "#BA55D3", // Orquídea Medio
    45: "#9370DB", // Púrpura Medio
    46: "#3CB371", // Verde Mar Medio
    47: "#7FFF00", // Verde Primavera
    48: "#DB7093", // Rosa Pálido
    49: "#FFB6C1"  // Rosado Claro
  },
}

module.exports = datos